import { Injectable } from '@angular/core';
import {
    MatSnackBar,
    MatSnackBarHorizontalPosition,
    MatSnackBarVerticalPosition
} from '@angular/material/snack-bar';
import { SnackBarComponent } from './snack-bar.component';

interface IOpenSnackbarParams {
    message: string
    action?: string,
    hPosition?: MatSnackBarHorizontalPosition,
    vPosition? : MatSnackBarVerticalPosition,
    className?: string,
    permanent?: boolean
    snack_type?: string
    title?: string
}

@Injectable({
  providedIn: 'root'
})
export class SnackBarService {

  constructor(private matSnackBar: MatSnackBar) { }

  openSnackBar(snack_params: IOpenSnackbarParams) {
    const {
        message,
        action,
        hPosition,
        vPosition,
        className,
        permanent,
        snack_type,
        title
    } = snack_params

    return this.matSnackBar.openFromComponent(SnackBarComponent, {
        data: { title, message, action, snack_type },
        announcementMessage: message,
        politeness: 'polite',
        duration: permanent ? Number.POSITIVE_INFINITY : 5000,
        horizontalPosition: hPosition ? hPosition : 'center',
        verticalPosition: vPosition ? vPosition : 'top',
        panelClass: [className || '']
        // direction: "rtl"
    })
  }
}
